"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Persons = void 0;
const PersonsItem_1 = require("./PersonsItem");
const DetermineMissingRoles_1 = require("../../../types/DetermineMissingRoles");
exports.Persons = {
    items: PersonsItem_1.PersonsItem,
    min: 1,
    max: 100,
    // @ts-ignore
    determineMissingRoles: (payload) => (0, DetermineMissingRoles_1.determineMissingRoles)(payload),
};
